<template>
  <div>
    <div class="title-header mb60">
      <router-link class="title-header__prev" :to="prev">
        <img src="/img/prev.svg" alt="">
      </router-link>
      <div class="text-center">
        <h2 class="h2 text-no-transform c-blue mb5">{{$route.meta.title}}</h2>
        <span class="fz22">Вы выбрали:</span>
      </div>
    </div>
    <div class="row justify-content-center mb60 pt10">
      <div class="col-xl-5 col-lg-7 col-md-9">
        <div class="fz18 mb10" v-for="item in $store.state.answers.testData">
          <span>{{item.name}}: </span>
          <span class="c-blue">{{item.value}}</span>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center pt25 mb60">
      <router-link class="btn btn--blue btn--ok" :to="{name: 'menu'}">Ok</router-link>
    </div>
  </div>
</template>

<script>
  export default {
    name: "EndCheck",
    computed: {
      prev() {
        if (this.$route.params.q_id != 0) {
          return {name: 'check-answers'};
        }
        else {
          return {name: 'check-generations'};
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        if (vm.$store.state.answers.testData.length === 0) {
          vm.$router.push({name: 'check-brands'});
        }
      });
    },
  }
</script>

<style scoped>

</style>